import { useContext, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Grid } from "@mui/material";
import { toast } from "react-toastify";
import axios from "axios";
import BASE_URL from "../../../constants/baseUrls";
import { LocaleContext } from "../../../routing/LangRouter";
import { t } from "i18next";
import { navigateToLoginPage } from "../../../utils/utility";
import { IS_MOBILE } from "../../../constants/breakpoints";

//import general components
import { BaseButton } from "../../../components/common/base-button/base-button";
import QuestionModal from "../../../components/common/question-modal/question-modal";
import BaseTitle from "../../../components/common/base-title/base-title";

//import styles
import "./delete-account.scss";

function DeleteAccount() {
    //general
    const navigate = useNavigate();
    const location = useLocation();
    const { locale } = useContext(LocaleContext);
    const accessToken = localStorage.getItem("accessToken");

    //modal
    const [open, setOpen] = useState(false);

    const handleDeleteAccount = () => {
        setOpen(true);
    };

    const deleteAccount = async () => {
        try {
            const response = await axios.delete(`${BASE_URL}/api/v2/account/user/delete/`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            localStorage.removeItem("accessToken");
            localStorage.removeItem("refreshToken");
            localStorage.removeItem("userInformation");
            navigate(`/${locale}`);
            toast.success(response.data.data.detail);
        } catch (error) {
            if (error.response.status === 401) {
                localStorage.clear();
                navigateToLoginPage(navigate, locale, location);
            } else {
                toast.error(t("Toast Messages.Error Occurred"), { toastId: "custom-id-yes" });
            }
        } finally {
            setOpen(false);
        }
    };

    return (
        <Grid className="delete-account" container item xs={12} rowGap={2} mt={{ xs: 2, md: 0 }} mb={5}>
            {!IS_MOBILE && <BaseTitle title={`${t("deleteAccount")}`} dividerColor="1px solid var(--medium-gray-color)" />}

            <Grid container item xs={12} direction="column" rowGap={2}>
                <span>{t("deleteAlarmText")}</span>
                <ul className="delete-account__list">
                    <li className="delete-account__details">{t("financialInformation")}</li>
                    <li className="delete-account__details">{t("transactionsInformation")}</li>
                    <li className="delete-account__details">{t("bookingsAndOrdersInformation")}</li>
                </ul>
            </Grid>

            <Grid container item xs={12} md={2}>
                <BaseButton text={t("deleteAccount")} color="red" radius="radius-10" size="medium" handleClick={handleDeleteAccount} />
            </Grid>

            <QuestionModal
                open={open}
                setOpen={setOpen}
                question={t("areYouSureYouWantToDeleteYourAccount")}
                colorYes="red-20"
                colorNo="teal-18"
                handleClick={deleteAccount}
            />
        </Grid>
    );
}

export default DeleteAccount;
